import { render } from "./TopbarProgress.vue?vue&type=template&id=ae4e8b66"
import script from "./TopbarProgress.vue?vue&type=script&lang=js"
export * from "./TopbarProgress.vue?vue&type=script&lang=js"
script.render = render

export default script